module.exports = __webpack_public_path__ + "static/img/6.c2b8539.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/zh/6.png
// module id = R6h6
// module chunks = 0